"use client";
import React, { useEffect, useState } from "react";
import LoadingOverlay from "../ui/loadingOverlay";

interface IProps {
  isLoading: boolean;
}

const WAIT_TIME = 1000;

const OverlayLoader = ({ isLoading }: IProps) => {
  const [showOverlay, setShowOverlay] = useState(false);
  const timerRef = React.useRef<NodeJS.Timeout | null>(null);
  const startTimeRef = React.useRef<number | null>(null);

  useEffect(() => {
    if (isLoading) {
      setShowOverlay(true);
      startTimeRef.current = Date.now();
      timerRef.current = setTimeout(() => {
        timerRef.current = null;
      }, WAIT_TIME);
    } else {
      if (startTimeRef.current) {
        const elapsed = Date.now() - startTimeRef.current;
        const remainingTime = Math.max(WAIT_TIME - elapsed, 0);

        if (remainingTime > 0) {
          setTimeout(() => {
            setShowOverlay(false);
          }, remainingTime);
        } else {
          setShowOverlay(false);
        }
      }
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [isLoading]);

  return <>{showOverlay && <LoadingOverlay />}</>;
};

export default OverlayLoader;
